import React, { useEffect, useState } from "react";
import {
  ContentState,
  convertFromRaw,
  convertToRaw,
  EditorState,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Grid from "@material-ui/core/Grid";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import { parseStringToJson } from "../../utils/utils";
import "./styles.css";

const SETextEditor = ({
  value,
  label,
  placeholder,
  style,
  notRequired = false,
  requiredColor = "#0061C6",
  maxLength = 140,
  showMaxLengthLabel = false,
  onChange = () => {},
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [currentValue, setCurrentValue] = useState();
  const [firstRender, setFirstRender] = useState(false);

  useEffect(() => {
    if (value && !firstRender) {
      setCurrentValue(value);
      setFirstRender(true);
    }
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (currentValue) {
      const contentBlocks = htmlToDraft(currentValue);
      const contentState = ContentState.createFromBlockArray(
        contentBlocks.contentBlocks,
        contentBlocks.entityMap
      );
      setEditorState(EditorState.createWithContent(contentState));
    }
  }, [currentValue]);

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    const html = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    onChange(html);
  };

  useEffect(() => {
    if (value) {
      try {
        const contentStateAsRaw = parseStringToJson(value);
        const contentState = convertFromRaw(contentStateAsRaw);
        setEditorState(EditorState.createWithContent(contentState));
      } catch (error) {
        console.error("Error parsing content from field value:", error);
      }
    }
  }, [value]);

  return (
    <div className="container-editor" style={style}>
      <div className="content-editor">
        <label className="label-editor">
          {label ?? placeholder}{" "}
          {!notRequired && <strong style={{ color: requiredColor }}>*</strong>}
        </label>

        <Editor
          editorState={editorState}
          onEditorStateChange={onEditorStateChange}
          wrapperClassName="wysiwyg-wrapper-editor"
          editorClassName="wysiwyg-editor"
        />
      </div>

      {!!showMaxLengthLabel && (
        <div style={{ display: "flex", alignSelf: "end" }}>
          <Grid item md={2} style={{ display: "flex", paddingTop: 4 }}>
            <span>{`${value?.toString()?.length ?? 0}/${maxLength}`}</span>
          </Grid>
        </div>
      )}
    </div>
  );
};

export default SETextEditor;
